<template>
    <v-dialog :value="showPopup" width="fit-content" @click:outside="$emit('cancel')">

        <v-card>
            <v-card-title>
                {{ title }}
            </v-card-title>
            <v-divider/>
            <v-card-text class="text--primary" v-html="text">

            </v-card-text>
            <v-card-actions>
                <v-spacer/>

                <v-btn :title="$t('title.cancel')" id="app-close-button" text @click="$emit('cancel')">
                    {{ $t('general.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>

    export default {
        name: 'AppPopup',
        props: {
            title: {type: String, default: ''},
            text: {type: String, default: ''},
            showPopup: {type: Boolean, default: false},
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../global';

    #app-close-button {
        color: $app-highlighted
    }
</style>

